module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_16"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478520"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Three")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("The Game Begins")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("As she prepared for her trip, Rebecca was filled with curiosity and apprehension. When her departure day arrived, she was anxious, not because she was leaving for a strange city in Japan to meet a mysterious man who had sent a vague message, but because Akio was rushing her out of her own store. He promised to take care of the books, but the hand at the base of her back hurrying her through the aisles towards the street was disconcerting. She barely had time to double check if she had her passport before the door closed firmly behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca glanced at her watch and realized that she still had time for a bite to eat before going to the airport. Fortuitously, she turned left down an alley towards her favorite falafel shop. If she had gone right and directly to the airport, the two thugs waiting for her would have been successful in their mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Instead, Rebecca had a leisurely snack while the two men waited impatiently. Frustrated and thinking that she must")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("have given them the slip, they decided to pay the bookstore a visit in hopes of gathering information to share with their employer. ")]), _c('span', {
    staticClass: "calibre33"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre34"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The larger of the two men entered the store first and his partner scurried in behind. Hoping to find the clerk distracted behind a counter, they were startled to see a Japanese gentleman confidently sitting in a large over-stuffed chair in the center")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("of the store. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio smiled warmly and greeted the men, “Please, make yourselves at home. I do hope you speak English.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The first man threateningly slid his hand into his coat pocket as if to retrieve a weapon and demanded, “Who are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio smiled confidently and said, “Since you are in my store, I think it is I who should ask, ‘Who are you?’”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The smaller of the men whined, “We’re asking the questions, clerk.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio maintained his demeanor and softly replied, “My name is Akio. Does that somehow help you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The larger man removed his hand from his coat revealing what Akio ")]), _c('span', {
    staticClass: "calibre36"
  }, [_vm._v("assumed was a Chinese pistol, but upon closer scrutiny he recognized it as ")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("a Tokarev TTM33, Chinese manufactured, but of Russian make.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Again, the smaller man spoke in a high nasally whine, “Don’t get smart with us. The woman, where is she?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio looked slowly over his shoulder in both directions and smiled before responding, “Not here, apparently.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The larger man stepped forward and shouted in Japanese, “")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Kanojo ga on’na?")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“As I told your friend, apparently she is not here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The man took another step forward and pointed the pistol at Akio’s forehead. He was about to issue another threat when Akio quietly asked, “Why do you pretend to be Japanese when you are obviously Chinese?” The larger man hesitated and Akio pressed the issue, “You have nearly flawless Japanese, but your slight accent gives you away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("From behind the hulking figure, the smaller man sniveled, “Let’s deal with him and get out of here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("As the man waved the gun in Akio’s face he threatened, “Tell the woman we will meet another time.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio shrugged and the smaller man kicked over a display, scattering hard covered books across the floor while sneering, “Maybe we will deal with you when we don’t require a messenger boy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio calmly said, “Unfortunately, there will NOT be another opportunity” and that elicited the response he desired. The larger man grabbed him by the scruff of his neck and lifted him out of the chair, giving Akio the energy needed to implement his Aikido training. With the gun pressed to Akio’s temple, he took the large man’s wrist and instead of trying to push him away, twisted the wrist and pinned it painfully against his own neck. A wrist bone could be heard breaking as the gun clattered to the floor. The larger man was thrown off balance and Akio quickly propelled his foot into the man’s gut, but again, instead of kicking him away, he used his foot as a lever. He brought the man closer still, allowing his foot to hurtle his enemy head-over-heels. The man landed awkwardly. The snapping of his neck sounded very much like a deadly pistol shot and was as effective. Akio instinctively kicked the gun under a table.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The smaller man was caught off guard and hesitated. A churlish cry escaped his throat and he reached into his pocket for a knife. The blade glinted as it slashed wildly in search of an artery. Despite his age, Akio rolled nimbly forward, his leg swung out and broke the man’s ankle. Screaming in pain, the thug staggered and fell. The bookstore went eerily silent. The stranger lay dead, bleeding from his own blade. Akio looked at the mess and sighed. It was indeed good fortune that he had hustled Rebecca out. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("A month earlier, Akio had discovered that Rebecca’s computer had been hacked. The invaders had been sloppy and easily traced back to China. He had deduced that once the message from Nara arrived that those who had done the hacking would send thugs to intimidate. It had been clear these were mid-level functionaries and not the high-level hackers used by the Communist Party. It also meant that for now they were amateurs, but if Akio was right in his theory, soon more would come…better hackers and more professional thugs. If this was indeed launched ")]), _c('span', {
    staticClass: "calibre36"
  }, [_vm._v("covertly by a member of ")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("the Politburo it wouldn’t be long until professional men, real soldiers, and devout communists")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("replaced these amateurs. Akio thought, ")]), _c('span', {
    staticClass: "calibre37"
  }, [_vm._v("someone inside")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" the Chinese")]), _c('span', {
    staticClass: "calibre12"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("government")]), _c('span', {
    staticClass: "calibre12"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("must indeed be scared.")]), _c('span', {
    staticClass: "calibre12"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The great game had begun.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre25"
  }, [_c('span', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_17"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07126e65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_006.vue
// module id = 78
// module chunks = 0